"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTransactionStructToCommitmentSummary = void 0;
const engine_1 = require("@railgun-community/engine");
const convertTransactionStructToCommitmentSummary = (transactionStruct, commitmentIndex) => {
    const commitmentCiphertextStruct = transactionStruct.boundParams
        .commitmentCiphertext[commitmentIndex];
    const commitmentCiphertext = (0, engine_1.formatCommitmentCiphertext)(commitmentCiphertextStruct);
    const commitmentHash = transactionStruct.commitments[commitmentIndex];
    return {
        commitmentCiphertext,
        commitmentHash,
    };
};
exports.convertTransactionStructToCommitmentSummary = convertTransactionStructToCommitmentSummary;
